import React from 'react';
import { Table, Button, Row, Col } from 'react-bootstrap';
import { RemoveParcel, PagingButtons } from '.';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export default function ParcelTable(props) {
  const {
    displayManage,
    hideTabs,
    sortedSubs,
    pageSize,
    currentPage,
    totalPages,
    alertsDescending,
    updatePagingInfo,
    updateAlertSort,
    updateParcels,
    error,
  } = props;

  return (
    <div className="br">
      <Row>
        <Col md="4">
          <h3 className="noLine">Your Parcels</h3>
        </Col>
        <Col md="8" className="error-col">
          <small className="text-danger small-danger-error">{error}</small>
        </Col>
      </Row>
      <Table responsive className="pr">
        <thead>
          <tr>
            <th>Actions</th>
            <th>Parcel Number</th>
            <th>Site Address</th>
            <th>eAlerts</th>
            <th><Button 
            variant="link" 
            aria-label='Last Alert Time, toggle ascending descending'
            onClick={() => {updateAlertSort(!alertsDescending); updatePagingInfo(pageSize, 1);}}>
              Last Alert (ET)
              </Button>
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedSubs
            .map((group) => (
              <tr key={group.parcelNumber}>
                <td>
                  <Button
                    variant="link"
                    size="sm"
                    aria-label={`Manage parcel ${group.parcelNumber.replace(/-/g, " - ")}`}
                    onClick={() => {
                      displayManage(group);
                    }}
                  >
                    Manage
                  </Button>
                  {' | '}
                  <RemoveParcel
                    parcelGroup={group}
                    parcelId={group.parcelNumber}
                    updateParcels={updateParcels}
                    hideTabs={hideTabs}
                  />
                </td>
                <td>
                    <a
                      href={
                        process.env.REACT_APP_AUDITOR_PARCEL_LOOKUP_URL +
                        group.parcelNumber
                      }
                      target="_blank"
                      rel="noreferrer"
                    aria-label={`Go to Parcel ${group.parcelNumber.replace(/-/g, " - ")}, details on Auditor's website`}
                    >
                      {group.parcelNumber}
                    </a>
                </td>
                <td>
                  {group.parcel === null
                    ? 'No address on file'
                    : group.parcel.siteAddress}
                </td>
                <td>{group.numberOfEalerts}</td>
                <td>
                  {format(
                    utcToZonedTime(
                      group.lastAlertTime + 'Z',
                      'America/New_York'
                    ),
                    'MMM d, yyyy h:mm a'
                  )}
                </td>
              </tr>
            ))}
          <tr className="tn">
            <td colSpan="99">
              <PagingButtons 
              pageSize={pageSize}
              currentPage={currentPage}
              totalPages={totalPages}
              updatePagingInfo={updatePagingInfo}/>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}
